import { render, staticRenderFns } from "./Dojo.vue?vue&type=template&id=78114294&"
import script from "./Dojo.vue?vue&type=script&lang=js&"
export * from "./Dojo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports